<template lang="html">

  <section class="header" :min="min" :inside="inside">
    <div class="superior">
      <div class="container row-between">
        <nav class="type-selector">
          <template v-for="(item, key) in $t('header')">
            <button v-if="item.title" :to="key" :active="$route.path.includes(key) || menuActive == key"
              @click="goTo(key)">
              {{ isMobile ? item.titleMobile : item.title }}</button>
          </template>
        </nav>

        <div class="row-start">
          <div class="contactos">
            <a class="phone-icon" href="tel:900848402" title="Enlace a llamar" aria-label="Enlace a llamar"><span
                @click="sendeventllamar">900 848 402</span></a>
          </div>
          <div class="right row-end">
            <rrss></rrss>
            <div class="language-selector">
              <i class="fa fa-globe" aria-hidden="true"></i>
              <span>Español</span>
            </div>
          </div>
        </div>

      </div>

    </div>

    <div class="inferior" :show="showmenu">
      <div class="container contenedor-menu row-between">
        <router-link to="/" class="contenedor-logo column-center">
          <span>Somos</span>
          <img class="white" src="/static/img/logo-iner-blanco.svg" alt="Logo Iner">
          <img class="orange" src="/static/img/logo-iner-orange.svg" alt="Logo Iner naranja">
        </router-link>
        <nav class="menu-options row-start" v-if="menuActive">
          <section v-for="(item, key) in $i18n.messages[$i18n.locale].header[menuActive].submenu" :key="key">
            <template v-if="key === 'tarifas' && typeof item === 'object'">
              <div class="tarifas-container" :show="showTarifas">
                <button :class="['row-center', ($route.meta.type == 'tarifa') ? 'router-link-active' : '']"
                  @click="showTarifas = !showTarifas"
                  :title="menuActive == 'general' ? 'Ver los servicios' : 'Ver las tarifas'"
                  aria-label="Ver las tarifas">
                  <span>{{ menuActive == 'general' ? 'Servicios' : 'Tarifas' }}</span>
                </button>
                <div class="menu-child" v-if="showTarifas && !isMobile">
                  <template v-for="(subitem, subkey) in item">
                    <button @click="toggleTarifaItem(subkey)" class="button-child"
                      :active="showTarifasItems.includes(subkey)" v-if="typeof subitem === 'object'">
                      <span>{{ subkey === 'autoconsumo' ? 'Solar' : subkey }}</span>
                    </button>
                    <router-link v-else :to="'/' + subkey" :title="'Enlace a ' + subkey" class="button-child not-menu"
                      :aria-label="'Enlace a ' + subkey" @click.native="menuActive = subkey">
                      <span>{{ subkey }}</span>
                    </router-link>
                    <div v-if="typeof subitem === 'object' && showTarifasItems.includes(subkey)" class="menu-child-sub">
                      <router-link v-for="(tarifa, tarifaKey) in subitem" :key="tarifaKey"
                        :to="'/' + subkey + '/' + tarifaKey" :title="'Enlace a ' + tarifa"
                        :aria-label="'Enlace a ' + tarifa">
                        {{ tarifa }}
                      </router-link>
                    </div>
                  </template>
                </div>
                <div class="menu-child" v-if="showTarifas && isMobile">
                  <template
                    v-for="(subitem, subkey) in $i18n.messages[$i18n.locale].header[menuActive].submenuResponsive">
                    <router-link :to="'/' + subkey" :active="$route.path.includes(key)">
                      {{ subitem }}
                    </router-link>
                  </template>
                </div>
              </div>
            </template>
            <template v-else>
              <router-link :to="menuActive === 'general' ? '/' + key : '/' + menuActive + '/' + key"
                :active="$route.path.includes(key)">
                {{ item }}
              </router-link>
            </template>
          </section>
          <router-link :to="menuActive === 'general' ? $t('enlaces.blog') :$t('enlaces.blog') + '?' + menuActive" title="Enlace a Blog"
            aria-label="Enlace a Blog">Blog</router-link>
          <router-link :to="$t('enlaces.contacto')" v-if="!inAutoconsumo">Contacto</router-link>

          <router-link :to="$t('enlaces.inergizate')" class="btn -white contrata" title="Enlace a contratar"
            v-if="!inAutoconsumo" aria-label="Enlace a contratar">CONTRATA</router-link>
          <router-link class="btn -white contrata" v-if="inAutoconsumo"
            :to="$t('enlaces.autoconsumo_ayudamos')">CONTACTA</router-link>
          <a rel="noopener" target="_blank" href="https://clientes.inerenergia.es/login"
            class="zona-clientes column-start" title="Enlace a zona clientes" aria-label="Enlace a zona clientes">
            <span class="big">Ya soy de Iner</span>
            <span class="small">Zona Clientes</span>
          </a>
          <section class="mobile-things-container bottom-menu">
            <a to="https://clientes.inerenergia.es/login" target="_blank" class="btn -white" title="Enlace a contratar"
              aria-label="Enlace a contratar">ZONA CLIENTES</a>
            <div class="row-between">
              <a class="phone-icon" href="tel:900848402" title="Enlace a llamar" aria-label="Enlace a llamar"><span
                  @click="sendeventllamar">900 848 402</span></a>
              <a class="mail-icon" href="mailto:iner@inerenergia.es" title="Enlace a mail" aria-label="Enlace a mail">
                <span>iner@inerenergia.es</span></a>
            </div>
            <div class="row-between">
              <rrss></rrss>
              <div class="language-selector">
                <i class="fa fa-globe" aria-hidden="true"></i>
                <span>Español</span>
              </div>
            </div>
          </section>
        </nav>

        <section class="mobile-things-container">
          <div class="mobile-things row-start">
            <router-link :to="$t('enlaces.inergizate')" class="btn -degree inergizate-claim" title="Enlace a contratar"
              aria-label="Enlace a contratar" v-if="!inAutoconsumo">CONTRATA</router-link>
            <router-link v-if="inAutoconsumo" :to="$t('enlaces.autoconsumo_ayudamos')"
              class="btn -degree inergizate-claim" title="Enlace a contacto autoconsumo"
              aria-label="Enlace a contacto autoconsumo">CONTACTA</router-link>
          </div>
          <button class="show-menu" @click="showmenu = !showmenu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </section>

      </div>

    </div>
  </section>

</template>

<script lang="js">
import rrss from '@/components/parts/rrss'
export default {
  name: 'app-header',
  data() {
    return {
      min: false,
      showTarifas: false,
      showTarifasItems: [],
      showmenu: false,
      menuActive: 'general'
    }
  },
  components: {
    'rrss': rrss
  },
  mounted() {
    let that = this;
    $(window).scroll(function () {
      let scroll = $(window).scrollTop();
      that.min = (scroll > 200);
    })
    this.setMenuActive();

  },
  watch: {
    '$route'() {
      this.setMenuActive();
    }
  },
  computed: {
    inside() {
      let notinside = ['home', 'empresas', 'autoconsumo'];
      return (!notinside.some(e => e == this.$route.name))
    },
    inAutoconsumo() {
      return (!!this.$route.meta.inautoconsumo);
    },
    isMobile() {
      return window.innerWidth < 970;
    }
  },
  methods: {
    setMenuActive() {
      this.showTarifas = false;
      this.showTarifasItems = [],
        this.showmenu = false;
      const urlParams = new URLSearchParams(window.location.search);
      for (let [key, value] of urlParams) {
        if (value) {
          this.menuActive = key;
          break;
        }
      }
      if (this.$route.meta.parentMenu) {
        this.menuActive = this.$route.meta.parentMenu
      }
      if (this.$route.meta.inautoconsumo) {
        this.menuActive = 'autoconsumo'
      }
      if (this.$route.name == 'home') {
        this.menuActive = 'general'
      }
    },
    toggleTarifaItem(subkey) {
      const index = this.showTarifasItems.indexOf(subkey);
      if (index === -1) {
        this.showTarifasItems.push(subkey);
      } else {
        this.showTarifasItems.splice(index, 1);
      }
    },
    goTo(key) {
      this.menuActive = key;
      // Si la key tiene un submenu en header.js y es un objeto, obtenemos la primera clave
      let ruta = '/' + key;
      const header = this.$i18n.messages[this.$i18n.locale].header;
      if (
        header[key] &&
        header[key].submenu &&
        typeof header[key].submenu === 'object' &&
        !Array.isArray(header[key].submenu)
      ) {
        // Obtenemos la primera clave del objeto submenu
        const primerSubmenu = Object.keys(header[key].submenu)[0];
        if (primerSubmenu) {
          ruta += '/' + primerSubmenu;
        }
      }
      if (this.$route.path !== ruta) {
        this.$router.push(ruta);
      }
    },
    sendeventllamar() {
      this.$ga.event({
        eventCategory: 'Home',
        eventAction: 'clic',
        eventLabel: 'clic-llamada',
        eventValue: 0
      });
      this.gtag_report_conversion();
    },
    gtag_report_conversion(url) {
      const callback = function () {
        if (typeof url !== 'undefined') {
          window.location = url;
        }
      };
      if (typeof gtag !== 'undefined') {
        gtag('event', 'conversion', {
          'send_to': 'AW-692816998/WlrfCIOgwfYaEOaYrsoC',
          'value': 1.0,
          'currency': 'EUR',
          'event_callback': callback
        });
      }
      return false;
    },
    /*     setLang(lang) {
          this.$i18n.locale = lang
        } */
  }
}
</script>

<style scoped>
@import '@/assets/css/colors.scss'
</style>


// WEBPACK FOOTER //
// src/components/parts/header.vue